import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import CardStyleSettings from './CardStyleSettings';

export default async function action() {
  return {
    title: 'Card Style Settings',
    component: (
      <AdminLayout>
        <CardStyleSettings />
      </AdminLayout>
    )
  };
}
